import reportHelpers from '../include/helpers';

export default {
  timeByProjects: {
    columns: [
      {
        accessorKey: 'task_name',
        // header: __('report_table_header_task_name'),
        header: __('group_by_task'),
        enableSorting: true,
        align: 'left',
        size: 'auto',
        cell: info => info.row.original.task_name,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'project',
        // header: __('report_table_header_project_name'),
        header: __('group_by_project'),
        enableSorting: true,
        enableGrouping: true,
        template: 'project',
        size: 132,
        icon: {
          name: 'project',
          type: 'regular',
          color: '#fff',
          size: 16,
        },
        align: 'left',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project.name,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.project?.name;
          const bValue = rowB.original.project?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'assignee',
        // header: __('report_table_header_assignee'),
        header: __('gantt_grid_assigned'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        template: 'resource',
        size: 132,
        cell: info => info.row.original.assignee,
        accessorFn: row => row.assignee?.id ?? 0,
        sortingFn: (rowA, rowB) => {
          function getData(rowData) {
            return Array.isArray(rowData) ? rowData[0] : rowData;
          }

          const aValue = getData(rowA.original.assignee)?.name;
          const bValue = getData(rowB.original.assignee)?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_projects_estimation'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        // cell: ({ row }) => row.original.estimation,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_projects_baseline'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'logs',
        // header: __('report_table_header_actual_cost'),
        header: __('report_time_by_projects_logs'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: true,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['task_name'],
        right: ['variance'],
      },
      columnOrder: [
        'task_name',
        'project',
        'assignee',
        'baseline_estimation',
        'estimation',
        'logs',
        'variance',
      ],
      columnVisibility: {
        task_name: true,
        project: true,
        assignee: true,
        baseline_estimation: true,
        estimation: true,
        logs: true,
        variance: true,
      },
    },
    aggregatedColumns: ['baseline_estimation', 'estimation', 'logs', 'variance'],
  },
  timeByMonth: calculationModel => ({
    columns: [
      {
        accessorKey: 'month',
        // header: __('report_table_header_task_name'),
        header: __('month').charAt(0).toUpperCase() + __('month').slice(1),
        enableSorting: false,
        align: 'left',
        size: 'auto',
        cell: info => info.row.original.month,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_month_basleline_estimation'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_month_estimation'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'logs',
        // header: __('report_table_header_actual_cost'),
        header: __('report_time_by_month_logs'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: false,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_baseline_estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_month_basleline_cumulative_estimation'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('cum_baseline_estimation_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_month_cumulative_estimation'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('cum_estimation_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_logs',
        // header: __('report_table_header_actual_cost'),
        header: __('report_time_by_month_cumulative_logs'),
        enableSorting: false,
        enableHiding: true,
        headerIconTooltip: {
          content: __('cum_logs_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance_cumulative'),
        headerIconTooltip: {
          content: __(`report_table_s_curves_time_cum_variance_tooltip_${calculationModel}`),
          iconName: 'info',
          iconColor: '#808080',
        },
        enableSorting: false,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['month'],
        right: ['cum_variance'],
      },
      columnOrder: [
        'month',
        'baseline_estimation',
        'estimation',
        'logs',
        'variance',
        'cum_baseline_estimation',
        'cum_estimation',
        'cum_logs',
        'cum_variance',
      ],
      columnVisibility: {
        month: true,
        estimation: true,
        baseline_estimation: true,
        logs: true,
        variance: true,
        cum_estimation: true,
        cum_baseline_estimation: true,
        cum_logs: true,
        cum_variance: true,
      },
    },
  }),
  timelogList: {
    columns: [
      {
        accessorKey: 'task',
        // header: __('report_table_header_task_name'),
        header: __('group_by_task'),
        enableSorting: true,
        enableGrouping: true,
        align: 'left',
        size: 'auto',
        icon: {
          name: 'task',
          type: 'regular',
          color: '#0D0D0D',
          size: 24,
        },
        cell: info => info.row.original.task.name,
        accessorFn: row => row.task?.id ?? 0,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.task?.name;
          const bValue = rowB.original.task?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'project',
        // header: __('report_table_header_project_name'),
        header: __('group_by_project'),
        enableSorting: true,
        enableGrouping: true,
        template: 'project',
        size: 132,
        icon: {
          name: 'project',
          type: 'regular',
          color: '#fff',
          size: 16,
        },
        align: 'left',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project?.id ?? 0,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.project?.name;
          const bValue = rowB.original.project?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'user',
        // header: __('report_table_header_assignee'),
        header: __('group_by_user'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        size: 132,
        template: 'resource',
        cell: info => info.row.original.user,
        accessorFn: row => row.user?.id ?? 0,
        sortingFn: (rowA, rowB) => {
          function getData(rowData) {
            return Array.isArray(rowData) ? rowData[0] : rowData;
          }

          const aValue = getData(rowA.original.user)?.name;
          const bValue = getData(rowB.original.user)?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'table_date',
        // header: __('report_table_header_budget'),
        header: __('group_by_date'),
        enableSorting: true,
        enableHiding: true,
        enableGrouping: true,
        align: 'left',
        size: 132,
        icon: {
          name: 'calendar',
          type: 'regular',
          color: '#0D0D0D',
          size: 24,
        },
        cell: info => info.row.original.table_date.value,
        accessorFn: row => row.table_date?.id ?? 0,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'table_time',
        // header: __('report_table_header_budget'),
        header: __('group_by_time'),
        enableSorting: true,
        enableHiding: true,
        enableGrouping: true,
        align: 'right',
        size: 132,
        icon: {
          name: 'timer',
          type: 'regular',
          color: '#0D0D0D',
          size: 24,
        },
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'comment',
        // header: __('report_table_header_actual_cost'),
        header: __('group_by_table_comment'),
        enableSorting: true,
        enableHiding: true,
        align: 'left',
        size: 280,
        // cell: ({ row }) => row.original.comment,
        cell: info => {
          const value = info.getValue();

          if (value === '') {
            return '—';
          }

          return value;
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['task'],
        right: ['comment'],
      },
      columnOrder: [
        'task',
        'project',
        'user',
        'table_date',
        'table_time',
        'comment',
      ],
      columnVisibility: {
        task: true,
        project: true,
        user: true,
        table_date: true,
        table_time: true,
        comment: true,
      },
    },
    aggregatedColumns: ['table_time'],
  },
  timeByResource: {
    columns: [
      {
        accessorKey: 'task',
        // header: __('report_table_header_task_name'),
        header: __('group_by_task'),
        enableSorting: true,
        align: 'left',
        size: 'auto',
        icon: {
          name: 'task',
          type: 'regular',
          color: '#0D0D0D',
          size: 24,
        },
        cell: info => info.row.original.task.name,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.task?.name;
          const bValue = rowB.original.task?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'project',
        // header: __('report_table_header_project_name'),
        header: __('group_by_project'),
        enableSorting: true,
        enableGrouping: true,
        template: 'project',
        size: 132,
        icon: {
          name: 'project',
          type: 'regular',
          color: '#fff',
          size: 16,
        },
        align: 'left',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project.name,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.project?.name;
          const bValue = rowB.original.project?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'assignee',
        // header: __('report_table_header_assignee'),
        header: __('gantt_grid_assigned'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        template: 'resource',
        size: 132,
        cell: info => info.row.original.assignee,
        accessorFn: row => row.assignee?.id ?? 0,
        sortingFn: (rowA, rowB) => {
          function getData(rowData) {
            return Array.isArray(rowData) ? rowData[0] : rowData;
          }

          const aValue = getData(rowA.original.assignee)?.name;
          const bValue = getData(rowB.original.assignee)?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_projects_estimation'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        // cell: ({ row }) => row.original.estimation,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_estimation',
        // header: __('report_table_header_budget'),
        header: __('report_time_by_projects_baseline'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'logs',
        // header: __('report_table_header_actual_cost'),
        header: __('report_time_by_projects_logs'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: true,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getTextValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['task'],
        right: ['variance'],
      },
      columnOrder: [
        'task',
        'project',
        'assignee',
        'baseline_estimation',
        'estimation',
        'logs',
        'variance',
      ],
      columnVisibility: {
        task: true,
        project: true,
        assignee: true,
        baseline_estimation: true,
        estimation: true,
        logs: true,
        variance: true,
      },
    },
    aggregatedColumns: ['baseline_estimation', 'estimation', 'logs', 'variance'],
  },
};
